;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.common.services')
    .factory('PaginationModel', PaginationModel)

  PaginationModel.$inject = ['$rootScope', 'PreferencesService']

  /**
   * Painless pagination
   */
  function PaginationModel ($rootScope, PreferencesService) {
    var model = this
    var AVAILABLE_PAGINATIONS = [5, 10, 25, 50, 100]

    function init () {
    }

    init()
    /** Number of pages to display to navigate. If there are more pages, a button with an ellipsis will be added */
    var DISPLAYED_PAGES = 5
    /** How many elements per page are allowed */

    var defaults = {
      perPage: AVAILABLE_PAGINATIONS[1],
      currentPage: 0
    }

    /**
     *
     * @param {Object} options
     * @param {string} options.path - The path to save and restore this pagination.
     * @constructor
     */
    function Pagination (options) {
      if (!options || !options.path) {
        throw new Error('Pagination should have a path (for saving)')
      }
      this.perPage = options.perPage || defaults.perPage
      this.currentPage = options.currentPage || defaults.currentPage
      this.orderBy = options.orderBy
      this.reverse = options.reverse
      this.path = options.path
      this.columns = options.columns
      this.search = options.search || {}
      this.totalElements = options.totalElements

      var self = this

      // TODO Remove, faire des setter avec callback sur search pour remplacer
      // Le watcher vit sur $rootScope : il doit être retiré par destroy() quand la page
      // qui utilise la pagination est détruite, sinon il retient la pagination (et ce
      // qu'elle référence) et alourdit chaque digest. Propriété non énumérable pour ne
      // pas être sérialisée par save() ni comparée par angular.equals / _.isEqual.
      Object.defineProperty(this, '_unwatchSearch', {
        value: $rootScope.$watch(function () {
          return self.search
        }, function (newValue, oldValue) {
          if (newValue !== oldValue) {
            self.currentPage = 0
          }
        }, true),
        writable: true,
        enumerable: false
      })
    }

    Pagination.prototype = {
      /**
       * Retire le watcher $rootScope de la pagination (idempotent).
       * La pagination reste utilisable (save, toQueryOptions...) : seule la remise
       * à zéro automatique de currentPage sur changement de search est désactivée.
       */
      destroy: function () {
        if (this._unwatchSearch) {
          this._unwatchSearch()
          this._unwatchSearch = null
        }
      },

      /**
       * Save in local Storage
       */
      save: function () {
        var self = this
        PreferencesService.getGeneralPrefs().then(function (prefs) {
          _.set(prefs, 'settings.' + self.path, self)
          prefs.save()
        })
      },

      /**
       * Builds an object ready to be passed to angular-orm's QueryBuilders' paginate function
       * @returns {{skip: number, limit: number, sort: string}}
       */
      toQueryOptions: function () {
        var queryOptions = {
          skip: this.perPage * (this.currentPage),
          limit: this.perPage
        }
        if (this.orderBy && this.orderBy !== '') {
          queryOptions.sort = (!this.reverse ? '-' : '') + this.orderBy
        }
        return queryOptions
      },
      getAvailablePaginations: function () {
        return AVAILABLE_PAGINATIONS
      },
      setPage: function (page) {
        this.currentPage = page
      },
      /**
       * Calculates the number of pages
       * @returns {number}
       */
      pageNumber: function () {
        return Math.ceil(this.totalElements / this.perPage)
      },
      /**
       * Creates an array the size of the number of pages
       * Used for ng-repeats
       * @returns {Array}
       */
      paginateArray: function () {
        return new Array(isNaN(this.pageNumber()) ? 0 : this.pageNumber())
      },
      prevPage: function () {
        this.currentPage -= 1
      },
      nextPage: function () {
        this.currentPage += 1
      },
      lastPage: function () {
        return Math.ceil(this.totalElements / this.perPage) - 1
      },
      /**
       * Should we display the number, or is it to be hidden because out of range ? (see DISPLAYED_PAGES)
       * @param number
       * @returns {boolean}
       */
      displayPageNumber: function (number) {
        return (number >= this.currentPage - DISPLAYED_PAGES && number <= this.currentPage + DISPLAYED_PAGES) || (number === 0) || (number === this.pageNumber - 1)
      },
      /**
       * returns the number or an hellip; if this is the last displayed page (see DISPLAYED_PAGES)
       * @param number
       * @returns {*}
       */
      displayPageNumberValue: function (number) {
        if ((number === this.currentPage - DISPLAYED_PAGES || number === this.currentPage + DISPLAYED_PAGES) && number !== 0 && number !== this.pageNumber - 1) {
          return '&hellip;'
        }
        return number + 1
      }
    }

    /**
     *   Retrieves a specific pagination or creates a new one if needed.
     * @param {string} path - The path to the pagination.
     * @param {Object} [opts] - Pagination options in the event of a creation (defaults)
     * @constructor
     */
    function get (path, opts) {
      return PreferencesService.getGeneralPrefs().then(function (prefs) {
        var options = _.get(prefs.settings, path) || opts || {}
        options.path = path
        return new Pagination(options)
      })
    }

    function getRaw (opts = {}) {
      const random = Math.floor(Math.random() * (1 - 10 + 1)) + 10
      const options = { ...opts, path: `pagination${random}` }
      return new Pagination(options)
    }

    return {
      // Model
      get: get,
      getRaw

    }
  }
})(window.angular, window._)
